import { AclEntity, RateSortMethod } from '@rygen/rygen-ui/model';

import { Carrier } from '../Carrier';

import { PreferredCarrier } from './PreferredCarrier';

export class RoutingGuideRule extends AclEntity {
  id?: number;
  name?: string;
  preferredCarriers: PreferredCarrier[] = [];
  excludedCarriers: Carrier[] = [];
  sortMethod = RateSortMethod.COST;
  active: boolean = true;

  constructor(opts?: Partial<RoutingGuideRule>) {
    super(opts);

    if (opts?.id != null) {
      this.id = opts.id;
    }
    if (opts?.name != null) {
      this.name = opts.name;
    }
    if (opts?.preferredCarriers != null) {
      this.preferredCarriers = opts.preferredCarriers.map(
        (c) => new PreferredCarrier(c),
      );
    }
    if (opts?.excludedCarriers != null) {
      this.excludedCarriers = opts.excludedCarriers.map((c) => new Carrier(c));
    }
    if (typeof opts?.sortMethod === 'string') {
      this.sortMethod = RateSortMethod[opts.sortMethod];
    } else if (opts?.sortMethod != null) {
      this.sortMethod = opts.sortMethod;
    }
    if (opts?.active != null) {
      this.active = opts.active;
    }
  }
}
